/**
 * Importing this expects that __LR__ is defined in the global scope.
 * When an application is loaded via the lobster-roll-host, it will
 * inject the __LR__ variable into the global scope.
 */
export const runtime = window.__LR__;
